export default "/8522fe2631ecefb1e3967be9883671f05392a386/bce1c79c076cfd26ce49a1f2fa85ca50.svg";